// extracted by mini-css-extract-plugin
export default {"base":"ScrollToTop_base__Qtjv9","isVisible":"ScrollToTop_isVisible__ee7RD"};